export enum MethodsOfOralHygieneChartFields {
  BrushingTeethFrequencyAction = 'BrushingTeethFrequencyAction',
  BrushingTeethFrequencyPlan = 'BrushingTeethFrequencyPlan',
  BrushingTeethMethodAction = 'BrushingTeethMethodAction',
  BrushingTeethMethodPlan = 'BrushingTeethMethodPlan',
  BrushingTeethMethodDetail = 'BrushingTeethMethodDetail',
  BrushingTeethRoutineAction = 'BrushingTeethRoutineAction',
  BrushingTeethRoutinePlan = 'BrushingTeethRoutinePlan',
  BrushingTeethRoutineDetail1 = 'BrushingTeethRoutineDetail1',
  BrushingTeethRoutineDetail2 = 'BrushingTeethRoutineDetail2',
  BrushingTeethTimeAction = 'BrushingTeethTimeAction',
  BrushingTeethTimePlan = 'BrushingTeethTimePlan',
  BrushingTeethIntensityAction = 'BrushingTeethIntensityAction',
  BrushingTeethIntensityPlan = 'BrushingTeethIntensityPlan',
  ToothpasteTypesAction = 'ToothpasteTypesAction',
  ToothpasteTypesPlan = 'ToothpasteTypesPlan',
  OralCareProductAction = 'OralCareProductAction',
  OralCareProductPlan = 'OralCareProductPlan',
  OralCareProductDetail = 'OralCareProductDetail',
  DietaryAssessmentAction = 'DietaryAssessmentAction',
  DietaryAssessmentPlan = 'DietaryAssessmentPlan',
  DietaryAssessmentDetail1 = 'DietaryAssessmentDetail1',
  DietaryAssessmentDetail2 = 'DietaryAssessmentDetail2',
  DietaryAssessmentDetail3 = 'DietaryAssessmentDetail3',
}

export enum BrushingTeethMethod {
  method1 = '횡마법',
  method2 = '회전법',
  method3 = '위아래로',
  method4 = '바스법',
  method5 = '전동칫솔',
  method6 = '이닦기_기타',
}

export const BrushingTeethMethodLabel = {
  [BrushingTeethMethod.method1]: '횡마법(옆으로)',
  [BrushingTeethMethod.method2]: '회전법',
  [BrushingTeethMethod.method3]: '위・아래로',
  [BrushingTeethMethod.method4]: '바스법(진동)',
  [BrushingTeethMethod.method5]: '전동칫솔',
  [BrushingTeethMethod.method6]: '기타',
};

export enum BrushingTeethRoutine {
  routine1 = '하루 세 번 이상',
  routine2 = '하루 두 번',
  routine3 = '하루 한 번',
}

export const BrushingTeethRoutineLabel = {
  [BrushingTeethRoutine.routine1]: '하루 세 번 이상',
  [BrushingTeethRoutine.routine2]: '하루 두 번',
  [BrushingTeethRoutine.routine3]: '하루 한 번',
};

export enum BrushingTeethTime {
  time1 = '3분 이상',
  time2 = '1~2분',
  time3 = '1분 미만',
}

export const BrushingTeethTimeLabel = {
  [BrushingTeethTime.time1]: '3분 이상',
  [BrushingTeethTime.time2]: '1~2분',
  [BrushingTeethTime.time3]: '1분 미만',
};

export enum BrushingTeethIntensity {
  soft = '부드럽게',
  hard = '힘을 주어',
}

export const BrushingTeethIntensityLabel = {
  [BrushingTeethIntensity.soft]: '부드럽게',
  [BrushingTeethIntensity.hard]: '힘을 주어',
};

export enum ToothpasteTypes {
  type1 = '불소 함유 치약',
  type2 = '불소가 함유되지 않은 치약',
}

export const ToothpasteTypesLabel = {
  [ToothpasteTypes.type1]: '불소 함유 치약',
  [ToothpasteTypes.type2]: '불소가 함유되지 않은 치약',
};

export enum OralCareProduct {
  product1 = '치간칫솔',
  product2 = '치실',
  product3 = '구강양치액',
  product4 = '슈퍼플로스',
  product5 = '치간자극기',
  product6 = '워터픽',
  product7 = '혀 세척기',
  product8 = '구강관리용품_기타',
}

export const OralCareProductLabel = {
  [OralCareProduct.product1]: '치간칫솔',
  [OralCareProduct.product2]: '치실',
  [OralCareProduct.product3]: '구강양치액',
  [OralCareProduct.product4]: '슈퍼플로스',
  [OralCareProduct.product5]: '치간자극기',
  [OralCareProduct.product6]: '워터픽',
  [OralCareProduct.product7]: '혀 세척기',
  [OralCareProduct.product8]: '기타',
};

export enum DietaryAssessment {
  dietary1 = '일일 간식 섭취 횟수',
  dietary2 = '설탕 함유 음식 섭취 횟수',
  dietary3 = '탄산음료 섭취 횟수',
}

export const DietaryAssessmentLabel = {
  [DietaryAssessment.dietary1]: '일일 간식 섭취 횟수 :',
  [DietaryAssessment.dietary2]: '설탕 함유 음식 섭취 횟수 :',
  [DietaryAssessment.dietary3]: '탄산음료 섭취 횟수 :',
};

export const MethodsOfOralHygieneChartFormDefaultValues = {
  [MethodsOfOralHygieneChartFields.BrushingTeethFrequencyAction]: undefined,
  [MethodsOfOralHygieneChartFields.BrushingTeethFrequencyPlan]: '',
  [MethodsOfOralHygieneChartFields.BrushingTeethMethodAction]: [],
  [MethodsOfOralHygieneChartFields.BrushingTeethMethodPlan]: '',
  [MethodsOfOralHygieneChartFields.BrushingTeethMethodDetail]: '',
  [MethodsOfOralHygieneChartFields.BrushingTeethRoutineAction]: undefined,
  [MethodsOfOralHygieneChartFields.BrushingTeethRoutinePlan]: '',
  [MethodsOfOralHygieneChartFields.BrushingTeethRoutineDetail1]: '',
  [MethodsOfOralHygieneChartFields.BrushingTeethRoutineDetail2]: '',
  [MethodsOfOralHygieneChartFields.BrushingTeethTimeAction]: undefined,
  [MethodsOfOralHygieneChartFields.BrushingTeethTimePlan]: '',
  [MethodsOfOralHygieneChartFields.BrushingTeethIntensityAction]: undefined,
  [MethodsOfOralHygieneChartFields.BrushingTeethIntensityPlan]: '',
  [MethodsOfOralHygieneChartFields.ToothpasteTypesAction]: undefined,
  [MethodsOfOralHygieneChartFields.ToothpasteTypesPlan]: '',
  [MethodsOfOralHygieneChartFields.OralCareProductAction]: [],
  [MethodsOfOralHygieneChartFields.OralCareProductPlan]: '',
  [MethodsOfOralHygieneChartFields.OralCareProductDetail]: '',
  [MethodsOfOralHygieneChartFields.DietaryAssessmentAction]: [],
  [MethodsOfOralHygieneChartFields.DietaryAssessmentPlan]: '',
  [MethodsOfOralHygieneChartFields.DietaryAssessmentDetail1]: undefined,
  [MethodsOfOralHygieneChartFields.DietaryAssessmentDetail2]: undefined,
  [MethodsOfOralHygieneChartFields.DietaryAssessmentDetail3]: undefined,
};
